<div class="content">
  <div class="row items-push">
    <div class="col-sm-12 text-left">
      <ol class="breadcrumb push-10-t">
        <li><a [routerLink]="['/']">Inicio</a></li>
        <li><a class="link-effect" [routerLink]="['/solicitudes-engie']">Solicitud</a></li>
        <li><span class="link-effect">Editar</span></li>
      </ol>
    </div>
  </div>
</div>
<div class="content">
  <div class="block">
    <div class="block-header">
      <h3 class="block-title">Editar Solicitud</h3>
    </div>
    <form #modelForm="ngForm" (ngSubmit)="onSubmit(modelForm)" appIdentityRevealed>

    <div class="block-content">
      <app-solicitud-master-progress [model]="model" [data]="model" [flujoCompleto]="model.aplicaPersonas"></app-solicitud-master-progress>
      <app-solicitud-master [model]="model" [data]="model" [disabled]="false" (tipoVisitaEventChanged)="getConfiguracionDocumentosPorTipoVisita($event)"></app-solicitud-master>
    </div>
    <div class="block-content">
        <div class="form-horizontal">
            <mat-divider class="engie-divider"></mat-divider>
        </div>

        <mat-tab-group>
          <mat-tab label="Personal">    
            <div class="form-horizontal">
              <div class="form-group">
                <div class="col-sm-12 text-right">
                  <button type="button" class="btn btn-new" mat-raised-button (click)="openDialogTipoDocumento(seccionPersonal)" ><mat-icon>description</mat-icon> Agregar Documento</button>
                  
                </div>
              </div>
            </div>
            
            <div class="table-responsive">
              <table #tablePersonal mat-table [dataSource]="model.lista_documentos_personal" class="table table-striped table-vcenter">
                <ng-container matColumnDef="nombre">
                  <th mat-header-cell *matHeaderCellDef>Documento</th>
                  <td mat-cell *matCellDef="let element" >{{ element.documento }}</td>
                </ng-container>
          
                <ng-container matColumnDef="requisito">
                  <th mat-header-cell *matHeaderCellDef>Requisito</th>
                  <td mat-cell *matCellDef="let element; let i = index" >
                    <ng-container *ngIf="element.esRequisitoBloqueado">{{textoTodos}}</ng-container>
                    <!-- {{element.idRequisito}}  -->
                    <!-- {{i}} -->
                    <mat-select name="documento_personal_{{i}}" matSelect [(ngModel)]="element.idRequisito" *ngIf="!element.esRequisitoBloqueado">
                      <mat-option
                          *ngFor="let item of listaTipoRequisitos; index as i"
                          [value]="item.idParametroDetalle"
                        >{{ item.valor}}</mat-option>
                    </mat-select>
                  </td>
                </ng-container>

                <ng-container matColumnDef="restringeAcceso">
                  <th mat-header-cell *matHeaderCellDef>Restringe Acceso</th>
                  <td mat-cell *matCellDef="let element">                      
                    <ng-container *ngIf="element.restringeAccesos">SI</ng-container>
                    <ng-container *ngIf="!element.restringeAccesos">NO</ng-container>
                  </td>
                </ng-container>
          
                <ng-container matColumnDef="acciones">
                  <th mat-header-cell *matHeaderCellDef>Acciones</th>
                  <td mat-cell *matCellDef="let element" > 
                    <button mat-icon-button color="primary" aria-label="Eliminar" (click)="deletePersona(element)" *ngIf="!element.restringeAccesos">
                      <mat-icon>delete</mat-icon>
                    </button>
                  </td>
                </ng-container>
          
                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
              </table>
  
            </div>              

          </mat-tab>
          <mat-tab label="Equipos">
            <div class="form-horizontal">
              <div class="form-group">
                <div class="col-sm-12 text-right">
                  <a class="btn btn-new" mat-raised-button (click)="openDialogTipoDocumento(seccionEquipos)" ><mat-icon>description</mat-icon> Agregar Documento</a>                  
                  
                </div>
              </div>
            </div>
            <div class="table-responsive" class="table table-striped table-vcenter">
              <table #tableEquipos mat-table [dataSource]="model.lista_documentos_equipos" class="table table-striped table-vcenter">
                <ng-container matColumnDef="nombre">
                  <th mat-header-cell *matHeaderCellDef>Documento</th>
                  <td mat-cell *matCellDef="let element">{{ element.documento }}</td>
                </ng-container>
          
                <ng-container matColumnDef="requisito">
                  <th mat-header-cell *matHeaderCellDef>Requisito</th>
                  <td mat-cell *matCellDef="let element; let i = index">
                    <ng-container *ngIf="element.esRequisitoBloqueado">{{textoTodos}}</ng-container>
                    <mat-select name="documento_equipo_{{i}}" matSelect [(ngModel)]="element.idRequisito" *ngIf="!element.esRequisitoBloqueado">
                      <mat-option
                          *ngFor="let item of listaTipoRequisitos; index as i"
                          [value]="item.idParametroDetalle"
                        >{{ item.valor }}</mat-option>
                    </mat-select>
                  </td>
                </ng-container>

                <ng-container matColumnDef="restringeAcceso">
                  <th mat-header-cell *matHeaderCellDef>Restringe Acceso</th>
                  <td mat-cell *matCellDef="let element">                      
                    <ng-container *ngIf="element.restringeAccesos">SI</ng-container>
                    <ng-container *ngIf="!element.restringeAccesos">NO</ng-container>
                  </td>
                </ng-container>
          
                <ng-container matColumnDef="acciones">
                  <th mat-header-cell *matHeaderCellDef>Acciones</th>
                  <td mat-cell *matCellDef="let element"> 
                    <button mat-icon-button color="primary" aria-label="Eliminar" (click)="deleteEquipo(element)" *ngIf="!element.restringeAccesos">
                      <mat-icon>delete</mat-icon>
                    </button>
                  </td>
                </ng-container>
          
                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
              </table>
            </div>
          </mat-tab>

          <mat-tab label="Vehiculos">
            <div class="form-horizontal">
              <div class="form-group">
                <div class="col-sm-12 text-right">
                  <a class="btn btn-new" mat-raised-button (click)="openDialogTipoDocumento(seccionVehiculos)"><mat-icon>description</mat-icon> Agregar Documento</a>                    
                </div>
              </div>
            </div>

            <div class="table-responsive" class="table table-striped table-vcenter">
              <table #tableVehiculos mat-table [dataSource]="model.lista_documentos_vehiculos" class="table table-striped table-vcenter">
                <ng-container matColumnDef="nombre">
                  <th mat-header-cell *matHeaderCellDef>Documento</th>
                  <td mat-cell *matCellDef="let element">{{ element.documento }}</td>
                </ng-container>
          
                <ng-container matColumnDef="requisito">
                  <th mat-header-cell *matHeaderCellDef>Requisito</th>
                  <td mat-cell *matCellDef="let element; let i = index">
                    <ng-container *ngIf="element.esRequisitoBloqueado">{{textoTodos}}</ng-container>
                    <mat-select name="documento_vehiculo_{{i}}" matSelect [(ngModel)]="element.idRequisito" *ngIf="!element.esRequisitoBloqueado">
                      <mat-option
                          *ngFor="let item of listaTipoRequisitos; index as i"
                          [value]="item.idParametroDetalle"
                        >{{ item.valor }}</mat-option>
                    </mat-select>
                  </td>
                </ng-container>

                <ng-container matColumnDef="restringeAcceso">
                  <th mat-header-cell *matHeaderCellDef>Restringe Acceso</th>
                  <td mat-cell *matCellDef="let element">                      
                    <ng-container *ngIf="element.restringeAccesos">SI</ng-container>
                    <ng-container *ngIf="!element.restringeAccesos">NO</ng-container>
                  </td>
                </ng-container>
          
                <ng-container matColumnDef="acciones">
                  <th mat-header-cell *matHeaderCellDef>Acciones</th>
                  <td mat-cell *matCellDef="let element"> 
                    <button mat-icon-button color="primary" aria-label="Eliminar" (click)="deleteVehiculo(element)" *ngIf="!element.restringeAccesos">
                      <mat-icon>delete</mat-icon>
                    </button>
                  </td>
                </ng-container>
          
                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
              </table>
              
            </div>
          </mat-tab>

          <mat-tab label="Documentación técnica">
            <div class="form-horizontal">
              <div class="form-group">
                <div class="col-sm-12 text-right">
                  <a class="btn btn-new" mat-raised-button (click)="openDialogTipoDocumento(seccionDocumentacionTecnica)" ><mat-icon>description</mat-icon> Agregar Documento</a>                    
                </div>
              </div>
            </div>

            <div class="table-responsive" class="table table-striped table-vcenter">
              <table #tableDocumentacionTecnica mat-table [dataSource]="model.documentosTecnicos" class="table table-striped table-vcenter">
                <ng-container matColumnDef="nombre">
                  <th mat-header-cell *matHeaderCellDef>Documento</th>
                  <td mat-cell *matCellDef="let element">{{ element.documento }}</td>
                </ng-container>
          
                <ng-container matColumnDef="requisito">
                  <th mat-header-cell *matHeaderCellDef>Requisito</th>
                  <td mat-cell *matCellDef="let element; let i = index">
                    <ng-container *ngIf="element.esRequisitoBloqueado">{{textoTodos}}</ng-container>
                    <mat-select name="documento_tecnico_{{i}}" matSelect [(ngModel)]="element.idRequisito" *ngIf="!element.esRequisitoBloqueado">
                      <mat-option
                          *ngFor="let item of listaTipoRequisitos; index as i"
                          [value]="item.idParametroDetalle"
                        >{{ item.valor }}</mat-option>
                    </mat-select>
                  </td>
                </ng-container>

                <ng-container matColumnDef="restringeAcceso">
                  <th mat-header-cell *matHeaderCellDef>Restringe Acceso</th>
                  <td mat-cell *matCellDef="let element">                      
                    <ng-container *ngIf="element.restringeAccesos">SI</ng-container>
                    <ng-container *ngIf="!element.restringeAccesos">NO</ng-container>
                  </td>
                </ng-container>
          
                <ng-container matColumnDef="acciones">
                  <th mat-header-cell *matHeaderCellDef>Acciones</th>
                  <td mat-cell *matCellDef="let element"> 
                    <button mat-icon-button color="primary" aria-label="Eliminar" (click)="deleteDocumentoTecnico(element)" *ngIf="!element.restringeAccesos">
                      <mat-icon>delete</mat-icon>
                    </button>
                  </td>
                </ng-container>
          
                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
              </table>              
            </div>
          </mat-tab>

        </mat-tab-group>

      <div class="form-horizontal pad-25">
        <div class="form-group">
            <div class="col-sm-12 text-right">
              <button type="submit" class="btn btn-naranja" (click)="save()" mat-raised-button ><mat-icon>save</mat-icon> Guardar</button>
              <button type="submit" class="btn btn-celeste" (click)="submit()" mat-raised-button ><mat-icon>send</mat-icon> Enviar</button>
              <a class="btn btn-naranja2" mat-raised-button (click)="closed()" ><mat-icon>exit_to_app</mat-icon> Salir</a>
            </div>
        </div>
      </div>
        
    </div>
  </form>
  </div>
</div>

<!-- <pre>{{ model | json }}</pre> -->
